import * as angular from 'angular';
import { mgoAngularWizard, PortfolioCodeUploadWizardContext } from '../custom';
import { BalancingAndPortfolioUploadWizardService } from 'app/_services/balancing-and-portfolio-upload-wizard.service';
import { UtilService } from 'app/_services/util.service';

class PortfolioCodeUploadWizardComponentCtrl implements ng.IController {
    public wizardName: string;
    public wizard: mgoAngularWizard.Wizard<PortfolioCodeUploadWizardContext>;
    private loadingExisting: boolean;

    constructor(
        private WizardHandler: mgoAngularWizard.WizardHandler<PortfolioCodeUploadWizardContext>,
        private utilService: UtilService,
        private $routeParams: ng.route.IRouteParamsService,
        private balancingAndPortfolioUploadWizardService: BalancingAndPortfolioUploadWizardService
    ) {
        this.wizardName = 'Manual portfolio code management';
    }

    $doCheck(): void {
        if (this.wizard) {
            return;
        }

        const wizard: mgoAngularWizard.Wizard<any> = this.WizardHandler.wizard(
            this.wizardName
        );

        if (wizard) {
            this.wizard = wizard;
            this.resetWizard();
        }
    }

    private resetWizard(): void {
        Object.keys(this.wizard.context).forEach(
            (key) => delete this.wizard.context[key]
        );
        this.wizard.context.data = <any>{};
        this.wizard.context.data.wizardGuid = this.utilService.generateGuid();

        const portfolioCodeNameFromRouteParam: any = this.$routeParams['name'];
        if (!angular.isUndefined(portfolioCodeNameFromRouteParam)) {
            this.editExistingPortfolioCode(portfolioCodeNameFromRouteParam);
        }
    }

    private editExistingPortfolioCode(portfolioCodeName: string) {
        this.loadingExisting = true;

        this.balancingAndPortfolioUploadWizardService
            .fetchByName(portfolioCodeName, 'PORTFOLIO')
            .then((res: PortfolioCodeAssignmentDto) => {
                this.wizard.context.currentPortfolioCode = res;
                this.wizard.goTo(1);
            })
            .finally(() => (this.loadingExisting = false));
    }
}

angular.module('app').component('pkpPortfolioCodeUploadWizard', {
    controller: PortfolioCodeUploadWizardComponentCtrl,
    template:
        require('app/portfolio-code-upload-wizard/portfolio-code-upload-wizard.component.html'),
    bindings: {}
});
